import {
    LOGIN, LOGOUT, SET_LOADING, SET_USERDETAILS, SET_LANGUAGE, SET_OTP_TIME,
    SET_EMAIl_VERIFIED, SET_DARK_MODE, SET_AVAILABILITY, SET_SUPPLIERDETAILS, SET_2FA_ENABLED, SET_2FA_VERIFIED, INCREMENT_SUPPLIER_CREDITS, SET_SUPPLIER_CREDITS
} from "./user.types";


export const setLogin = (payload) => ({
    type: LOGIN,
    payload
});

export const setLogout = () => ({
    type: LOGOUT,
});

export const setLoading = (val) => ({
    type: SET_LOADING,
    payload: val
});

export const setUserDetails = (payload) => ({
    type: SET_USERDETAILS,
    payload
});
export const setSupplierDetails = (payload) => ({
    type: SET_SUPPLIERDETAILS,
    payload
});

export const setLanguage = (val) => ({
    type: SET_LANGUAGE,
    payload: val
});

export const setOtpTime = (val) => ({
    type: SET_OTP_TIME,
    payload: val
});

export const setEmailVerified = (val) => ({
    type: SET_EMAIl_VERIFIED,
    payload: val
});

export const setDarkMode = (val) => ({
    type: SET_DARK_MODE,
    payload: val
});

export const setAvailability = (val) => ({
    type: SET_AVAILABILITY,
    payload: val
});

export const set2fa = (payload) => ({
    type: SET_2FA_ENABLED,
    payload
});

export const set2faVerified = (payload) => ({
    type: SET_2FA_VERIFIED,
    payload
});

export const incrementSupplierCredits = (payload) => ({
    type: INCREMENT_SUPPLIER_CREDITS,
    payload
});

export const setSupplierCredits = (payload) => ({
    type: SET_SUPPLIER_CREDITS,
    payload
});